module.exports = __webpack_public_path__ + "static/shptyy-d1619f3c2c1b636222e23468de88ac05.jpg";